// @flow
import type { ActionsState } from '~/core/state/actions/types';
import type { ConnectProps, HiveLiveRequirement } from './types';

import { connect } from 'react-redux';
import { getConfig } from '~/core/state/config/selectors';
import { initialiseFormFromTemplate, listDevicesForActionAttribute } from '~/core/state/actions/selectors';
import { getHasEntitlement } from '~/core/state/entitlements/selectors';
import { getHasHub } from '~/core/state/hub/selectors';
import { getIsHubNano1 } from '~/core/state/devices/selectors';
import { loadForm } from '~/core/state/actions/actions';
import Component from './component';

const checkIfMissingDevice = (state, attribute): boolean => {
    if (attribute.required && attribute.devices) {
        // $FlowFixMe
        return listDevicesForActionAttribute(state, {
            types: attribute.devices || []
        }).length > 0
            ? false
            : true;
    }
    return false;
};

const checkHiveLive = (state, attribute): HiveLiveRequirement =>
    attribute.entitlements
        ? attribute.entitlements.some(entl => getHasEntitlement(state, entl))
          ? 'requiredAndHave'
          : 'requiredButDontHave'
        : 'notRequired';

const mapStateToProps = (state: { actions: ActionsState }, { template }: ConnectProps) => {
    const isNano1 = getIsHubNano1(state);
    const [when, _while, then] = [template.when, template.while, template.then].map(arr =>
        arr.map(templateEvent => ({
            definition: templateEvent,
            hiveLive: checkHiveLive(state, templateEvent),
            missingDevice: checkIfMissingDevice(state, templateEvent)
        }))
    );

    const whenEventWithMissingDevice = when.find(templateEvent => templateEvent.missingDevice);
    const hiveActionsUrl = getConfig(state, 'help:hiveActions');
    const findOutMoreUrl = whenEventWithMissingDevice
        ? getConfig(state, `actions:requiredDeviceUrl:${whenEventWithMissingDevice.definition.type}`)
        : hiveActionsUrl;

    return {
        _while,
        description: template.description,
        findOutMoreUrl,
        hasHub: getHasHub(state),
        hiveActionsUrl,
        isNano1Incompatible: isNano1 && template.incompatible.includes('NANO1'),
        name: template.name,
        state,
        templateId: template.id,
        templateAvailable: !whenEventWithMissingDevice,
        then,
        when
    };
};

const mapDispatchToProps = {
    loadForm
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { state, templateId, ...restStateProps } = stateProps;
    const { loadForm } = dispatchProps;

    return {
        ...restStateProps,
        ...ownProps,
        chooseTemplate: () => loadForm(initialiseFormFromTemplate(state, { templateId }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template-description/index.js